import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { RoleBrief } from '../../types/role'
import TemplateRow from './RoleRow'
import TemplateRowSkeleton from './RoleRow.skeleton'
import useStyles from './styles/TemplatesTable.styles'

interface RolesTableProps {
  loading: boolean
  data: RoleBrief[] | undefined
  reloadData: () => void
}

export const RolesTable: React.FC<RolesTableProps> = ({
  loading,
  data,
  reloadData
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Role Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Description')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Status')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              reloadData()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill(null)
            .map((item, index) => (
              <TemplateRowSkeleton
                key={`template-row-skeleton${index.toString()}`}
              />
            ))
        : data &&
          data.map((singleRole) => (
            <TemplateRow
              key={singleRole.roleID}
              data={singleRole}
              refetchRolesList={reloadData}
            />
          ))}
    </div>
  )
}

export default RolesTable
